import { ComputationForm } from "../../../library-templates/inputs/computation--form/ComputationForm";
import { computeAvailableNumberOfTextures } from "./computeAvailableNumberOfTextures";
import { computeNetworkTraffic } from "./computeNetworkTraffic";

export class AddComputeFunctions
{
  static apply()
  {
    ComputationForm.addFunction( 
      "computeAvailableNumberOfTextures", 
      computeAvailableNumberOfTextures
    );

    ComputationForm.addFunction( 
      "computeNetworkTraffic", 
      computeNetworkTraffic
    );
  }
}